export default __webpack_public_path__ + "static/media/FemaleHeadTop.944fbbd0.png";